export const getAnagraficheGridColumns = ({ renderIsPgCell, renderCompleteCell, renderLegaleRappStatusCell }) => [
  {
    field: "id",
    headerName: "Id",
    type: "number",
    minWidth: 50,
    flex: 0.1,
    hide: true,
  },
  {
    field: "cf",
    headerName: "Codice Fiscale",
    minWidth: 50,
    flex: 0.3,
  },
  { field: "pIva", headerName: "P. Iva", minWidth: 50, flex: 0.3 },
  {
    field: "denominazione",
    headerName: "Denominazione",
    minWidth: 50,
    flex: 1,
  },
  {
    field: "isPg",
    headerName: "Persona giuridica",
    renderCell: renderIsPgCell,
    minWidth: 50,
    flex: 0.3,
  },
  {
    field: "isComplete",
    headerName: "Completo",
    renderCell: renderCompleteCell,
    minWidth: 50,
    flex: 0.3,
  },
  {
    field: "legaleRappStatus",
    headerName: "Legale rapp.",
    renderCell: renderLegaleRappStatusCell,
    minWidth: 110,
    flex: 0.4,
  },
];

export const fascicoliGridColumns = [
  { field: "fascicoloId", headerName: "Id", flex: 0.2 },
  { field: "cf", headerName: "Codice Fiscale", flex: 0.3 },
  {
    field: "pIva",
    headerName: "Partita Iva",
    flex: 0.3,
    editable: false,
  },
  {
    field: "denominazione",
    headerName: "Denominazione anagrafica",
    flex: 1,
    editable: false,
  },
];
